import { useRef, useState, useCallback } from "react";

export const BeforeAfterSlider = ({ before, after, beforeLabel = "ANTES", afterLabel = "CORTE SIMULADO", testid = "ba-slider", className = "" }) => {
  const [pos, setPos] = useState(50);
  const box = useRef(null);
  const drag = useRef(false);

  const move = useCallback((clientX) => {
    const r = box.current?.getBoundingClientRect();
    if (!r) return;
    setPos(Math.min(100, Math.max(0, ((clientX - r.left) / r.width) * 100)));
  }, []);

  const onDown = (e) => { drag.current = true; try { e.currentTarget.setPointerCapture?.(e.pointerId); } catch { /* noop */ } move(e.clientX); };
  const onMove = (e) => { if (drag.current) move(e.clientX); };
  const onUp = () => { drag.current = false; };
  const onKey = (e) => {
    if (e.key === "ArrowLeft") setPos((p) => Math.max(0, p - 5));
    if (e.key === "ArrowRight") setPos((p) => Math.min(100, p + 5));
  };

  return (
    <div ref={box} data-testid={testid}
      className={`relative w-full overflow-hidden rounded-[14px] border border-[#2a2a2a] select-none cursor-ew-resize bg-[#111] ${className}`}
      style={{ touchAction: "pan-y" }}
      onPointerDown={onDown} onPointerMove={onMove} onPointerUp={onUp} onPointerCancel={onUp}>
      <img src={after} alt="Corte simulado" draggable={false} className="block w-full h-auto pointer-events-none" />
      <img src={before} alt="Antes" draggable={false} className="absolute inset-0 w-full h-full object-cover pointer-events-none"
        style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }} />
      <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-black/70 text-[11px] font-bold tracking-widest text-white" data-testid={`${testid}-before-label`}>{beforeLabel}</span>
      <span className="absolute top-3 right-3 px-2.5 py-1 rounded-full bg-[#d4af37] text-[11px] font-bold tracking-widest text-black" data-testid={`${testid}-after-label`}>{afterLabel}</span>
      <div className="absolute top-0 bottom-0 w-[3px] bg-[#d4af37] -translate-x-1/2 pointer-events-none" style={{ left: `${pos}%` }}>
        <button type="button" role="slider" aria-label="Comparar antes y después" aria-valuenow={Math.round(pos)} aria-valuemin={0} aria-valuemax={100}
          onKeyDown={onKey} data-testid={`${testid}-handle`}
          className="pointer-events-auto absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-11 h-11 rounded-full bg-[#d4af37] text-black shadow-lg flex items-center justify-center font-black text-sm">
          ‹ ›
        </button>
      </div>
    </div>
  );
};
